import { version } from "./version";

export const environment = {
  URL_WEB:"https://web.aguamarina.liberasoft.cloud/",
  production: false,
  apiUrl:"https://api.aguamarina.liberasoft.cloud/b2b/",
  filesUrl:"https://api.aguamarina.liberasoft.cloud/files/",
  dateBuild: version.dateBuild,
  Version: version.Version,
  MODE:"B2C"
};
